/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { filter } from 'lodash';

const groupHasPeople = edge => edge.node.people.value.totalCount > 0;
export const filterEmptyGroups = edges => filter(edges, groupHasPeople);

// TODO this code is duplicated from frontend/src/pages/sor/new_object/utils.ts
const groupIsPrivateNoAccess = edge => {
  return (
    !edge.node.isPrivate.value ||
    (groupHasPeople(edge) && edge.node.people.value.edges[0].node.userRole.value !== 'No Access')
  );
};
export const filterNoAccessPrivateGroups = edges => filter(edges, groupIsPrivateNoAccess);

const toPrivateGroupLabel = (name: null | string, email: string) => (name ? `${name} (${email})` : email);
const toGroupLabel = (title: string) => `${title} (group)`;

const parsePrivateGroup = edge => {
  const id = edge.node.id;
  const groupTitle = edge.node.title.value;

  const person = edge.node.people.value.edges[0];
  const name = person.node.name && person.node.name.value;
  const email = person.node.email && person.node.email.value;

  return {
    id,
    value: id,
    label: toPrivateGroupLabel(name, email),
    groupTitle,
  };
};
const parseGroup = edge => {
  const id = edge.node.id;
  const title = edge.node.title.value;

  return {
    id,
    value: id,
    label: toGroupLabel(title),
    groupTitle: title,
  };
};
export const edgeToGroupDropdownOption = edge => {
  const isPrivate: boolean = edge.node.isPrivate.value;
  const parseFn = isPrivate ? parsePrivateGroup : parseGroup;

  return parseFn(edge);
};
